/* eslint-disable */

/**
 * 引进新的qing.js统一改造
 * @since 2023/02/28
 * @author 章武兵（80355348） - 移动平台组 - 流程IT部
 * @description 部分桥封装的不是很完善，这里只做一个demo示例，实际开发中遇到不适用的可以二次开发
 */

// 获取地理位置
export const getLocation = (callback) => {
  qing.call('getLocation', {
    // true、false 默认为 true 【新增 QingVersion:0.9.84】
    enableHighAccuracy: true,
    // true、false  是否允许离线使用【新增 QingVersion:0.9.84】（注意：如果开启离线模式，则只返回latitude、longtitude、accuracy）
    enableOffline: false,
    // true、false 是否通过后台maprest接口修正位置【新增 QingVersion:0.9.84】（注意：仅android,非离线模式下，设置才生效，默认为true）
    maprestVerify: true,
    success(res) {
      callback && callback(res)
    },
    error(err) {
      callback && callback(err)
    },
  })
}

// 选择周边位置 location：当前位置
export const selectLocation = (location = {}, callback) => {
  qing.call('selectLocation', {
    ...location,
    success(res) {
      callback && callback(res)
    },
    error(err) {
      callback && callback(err)
    },
  })
}

// 选人 
// 这里只做功能展示，具体的业务字段参考魔盒文档：
// https://gsm.myoas.com/docs/product?pn=%E7%A7%BB%E5%8A%A8%E5%B9%B3%E5%8F%B0&id=209&docsId=1663
export const selectPersons = (callback) => {
  qing.call('selectPersons', {
    isMulti: false,
    isShowMe: false,
    success(res) {
      callback && callback(res)
    },
  });
}

// 选组织
export const selectOrgs = (callback) => {
  qing.call('selectOrgs', {
    isMulti: false,
    success(res) {
      callback && callback(res)
    },
  });
}

// 混合应用（离线）获取ticket的方式
export const getTicketHybrid = (appId, callback) => {
  qing.call('getTicketHybrid', {
    appId,
    success(res) {
      let ticket = res.data ? res.data.ticket : ''
      callback && callback(ticket)
    },
  });
}

// 封装请求
export const request = (url, options, successCallback, errorCallback) => {
  qing.call('request', {
    url,
    method: 'post',
    serializer: options.serializer === undefined ? 'json' : null,
    data: options.data,
    headers: Object.assign({
      'Content-Type': 'application/json',
    }, options.headers || {}),
    success: successCallback,
    error: errorCallback
  })
}

// 非混合应用（在线）获取ticket的方式
export const getTicketH5 = (appId, callback) => {
  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  let serializer = ''   // 这个字段很重要
  let data = {
    deviceType: 1,
    appId
  }
  request('sso-service/lapp/info', { data, headers, serializer }, (res) => {
    console.log('sso-service/lapp/info success -> ', res)
    let ticket = ''
    if (res && res.data && res.data.url) {
      let url = res.data.url
      let result = url.match(/ticket=(\w+)&/)
      ticket = result[1] || ''
    }
    callback && callback(ticket)
  })
}

// 获取轻应用信息
export const getLightInfo = (appId, callback) => {
  request('/openaccess/lightapp/getLightInfo', { data: { appId } }, (res) => {
    callback && callback(res)
  }, () => {
    callback && callback()
  })
}

// 外部获取ticket的方式
export const getTicket = (appId, callback) => {
  getLightInfo(appId, (res) => {
    console.log('getLightInfo success -> ', res)
    if (res && res.data) {
      const { isEnableHybrid } = res.data
      // 支持离线
      if (isEnableHybrid) {
        getTicketHybrid(appId, (ticket) => {
          callback && callback(ticket)
        })
        return
      }
      // 获取在线应用的ticket
      getTicketH5(appId, (ticket) => {
        callback && callback(ticket)
      })
      return
    }
    callback && callback('')
  })
}

// 接管侧滑(iOS)
export const takeWebRightSlide = (isTakeOver) => {
  qing.call('takeWebRightSlide', {
    isTakeOver: isTakeOver ? 'y' : 'n'
  });
}

// 设置 title
export const setTitle = (title) => {
  qing.call('setWebViewTitle', {
    title
  })
  // 以下逻辑是为了兼容整体App的流程，大多数情况下，是不可复用的
  window.__title__ = title
  createPopDefault({
    title: window.__title__,
    description: '...',
    appLogo: '',
    // url: window.location.href + '?title=' + window.__title__,
    appName: '离线H5应用'
  })
}

// 隐藏 title
export const hideTitle = () => {
  qing.call('hideWebViewTitle')
  // 以下逻辑是为了兼容整体App的流程，大多数情况下，是不可复用的
  window.__title__ = ''
  createPopDefault({
    title: window.__title__,
    description: '...',
    appLogo: '',
    // url: window.location.href + '?title=' + window.__title__,
    appName: '离线H5应用'
  })
}

// 隐藏下拉菜单
export const closePop = () => {
  qing.call('closePop')
}

// 隐藏导航
export const hideNav = (hide) => {
  qing.call('setWebViewTitleBar', { isShow: hide })
}

// 关闭Webview
export const closeWebView = () => {
  qing.call('closeWebView')
}

// 自定义返回逻辑
export const defback = (callback) => {
  // 0.9.11及以上支持
  qing.call('defback', {
    intercept: true,
    success: (data) => {
      console.log("success",data)
      callback && callback()
    },
    error:(err) => {
      console.log(err)
  }})
}

// 释放接管返回逻辑
export const releaseDefback = () => {
  // 0.9.11及以上支持
  qing.call('defback', {
    intercept: false
  })
}

// 自定义关闭逻辑
export const defClose = (callback) => {
  // 0.9.11及以上支持
  qing.call('defClose', {
    intercept: true,
    success: () => {
      callback && callback()
    }
  })
}

// 创建拉下菜单(自定义)
export const createPop = (pop, items = [], before = null) => {
  const btns = items.map((item) => {
    return {
      text: item.title,
      callBackId: item.id,
    }
  })
  const cbs = [pop].concat(items)

  qing.call('createPop', {
    popTitle: (pop && pop.title) || '',
    popTitleCallBackId: (pop && pop.id) || '',
    menuList: [],
    items: btns,
    success(resp) {
      if (resp.success) {
        if (!resp.data) {
          return
        }
        let callBackId = resp.data.callBackId
        cbs.some((item) => {
          if (item.id == callBackId) {
            if (before && !before(item)) {
              return true
            }
            item.cb && item.cb()
            return true
          }
        })
      }
    },
  })
}

// 显示状态栏
export const showAppStatus = () => {
  qing.call('showAppStatus')
}

// 隐藏状态栏
export const hideAppStatus = () => {
  qing.call('hideAppStatus')
}

// 设为默认按钮
export const createPopDefault = (shareData) => {
  closePop()
  qing.call('createPop', {
    menuList: ['forward', 'refresh'],
    shareData,
  })
}

// 设为自定义按钮
export const createPopNew = () => {
  closePop()
  qing.call('createPop', {
    isExpand: true,
    //从右数第一个按钮
    firstRight: {
      'callbackId': 'firstRightId',
      'visible': true,
      'iconBase64': 'iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABVRJREFUaEPlmH+IVFUUx7/nzqh/xEKl/WEUGNky+959i2ZoZUS/f0BqBQ4ZFVqoCf2OEkqoIP+xwn5AtSv+CCElNEPFQKIyK8tamuadOxoWLWW/kyw2KtZ5J+7yJp7P2Z13Z1zZpQsPBuac77mf+/scwihvNMr7j/83gOd5U5VSc0RkPBFNADAewJ9E9IuI2G+HMeaD4Zxl5xno6OiYmMvlFhPRbBGZmqFzXwHYTkTrwzDsyWDvZJIZINHxhSJyeiLKNgDvAfjJfiLSppSaKCIdAOYCOK1mKyLdSqnu4wmSCSAIggtEZA2AQtwZO5KvVKvVTfv27fthqCELgmCuiNwKYFbCbhkzL3ca6kGMGwJorW8EsDn2LxHRS2EYdrsG11pfB2BRAmQLM1vtltqQAEEQLBKRrjjCmnw+/2CpVDrcSkSt9csAFtc0mfmOVvQGBQiCYJqIfBqLP8HMj7cSKOkbz4bdOxCRRcaYVc1qDwqgtd4F4GIA7zLzpc0GGMzP87z5Sqm1McRsY8wAkGurC6C1vhvA8wC4Wq1e1Wijugat2fu+v5aI5gN4i5mvbEbnGADf908loo8BTBaRecaYjc0IZ/Hp7OzUURR9BOCkKIoWVCqVdVn8kjbHAGit7Vp/DMBGZp7nKuhqr7W2x+kjAPYy8wxX/3oA9uq/UCl1frlctjMxrM33/clEdMAGiaJoRqVS2esS8CgA3/c9IjIi0muMOctFqBVb3/d3ENG1AJYz8zIXraMAastHRNYZYxa4CLVi6/v+PCJ6FcCHzDzTRSs9Ay8Q0V0AHmLmp12EWrENgiAQkTKAA8zc7qKVnoENAG4CcBszr3cRasW2UCiMz+fzvwI4zMynuGilAXYCsOfx1cxsf5+Q5nneWKXUPwD6mXmsS9A0wBYA1wO4kZnt7xPStNZnAvgGwHfMfIZL0KMAgiDoFpGFAJYws310nZCmtT4PwCcASsycJUn6r1/pGahdKsf18dZoFLTWtwBYLyJbjTFzGtkn/0+fQjOJ6P1mjjOXoGnbIAhWish9IrLUGLPCRaveTfwlgLNF5BxjjP097E1rPXB4iMhFrkWAegDPAriXiFaEYbh0uHufyA0+Z+YprvGOAUgmMs2MiGsHtNZbbZpJRA+EYbjS1b9uPuD7fhcR2XTSeVO5dCCR1Bw8cuTIlP379x9y8be2dQFS6WQXM9/pKtzIvlAoTMrlcu8Q0SQRud8YY5eucxsqpXwUwJOx4ixm3u6sPohDe3v7hDFjxqy2xTEi2hCG4c3Nag9ZldBavw7ghuMJobW+BIB9KE6zT/coiorGmMqwAFhRrfVqALfHAR5m5qeaDZbI9hDnHT6AslKqWC6Xv2hGt2Fhy4r6vr+QiAaKWSKyG8BzxphasathXPvej4/mWsq4RkSeUUq9JiK+iHwGwM6E872TCSCGsEfdPQCuiHtcJqLdIrLJ1kSJ6McwDH+r0XR2dp4bRdFlRHS5iFwzcGIQfR9F0XJjzIuxpleDsG+hfD5fLJVKvQ1HJGGQGaDmEx99SwBMzxrIdlxEVlWr1a50icamsQkIW6EoMvO3mbWzGqbtPM+brpSaDcAWvWwF2n4nJ+wOicg2+7aqVqs7hqotpSCsfTFrLcp5BpoFbuSXgtgVb+yfG/mNGID0niCit/v7+4uNbucRBVBnY+8cN25csaen5/fBZmLEAaQhRORNESlWKpW+ehAjEqDOTGzr6+sr9vb2/p2GGLEAdSDeiJdTfxJiRAPUgdjMzEVbRq1BjHiAFMTXbW1txT179vw1qgBqELlc7o9yuXxwVC2hUXWRNersqDpGs8L8C4aIXE/y/hzXAAAAAElFTkSuQmCC',
      'title': '礼貌',
      'textColor': '#36BF36',
    },
    //从右数第二个按钮
    secondRight: {
      'callbackId': 'secondRightId',
      'visible': true,
      'title': "更多",
      'textColor': '#36BF36',
    },
  })
}

// 分享
export const share = (data, callback) => {
  qing.call('mtp.share', {
    shareType: '4',
    ...data,
    success(res) {
      callback && callback(res)
    },
    error(err) {
      callback && callback(err)
    },
  })
}

// 免费电话（云之家已经不再提供免费电话）
export const freeCall = (oid, callback) => {
  qing.call('freeCall', {
    openId: oid,
    success(res) {
      callback && callback(res)
    },
    error(err) {
      callback && callback(err)
    },
  })
}

// 设置 iOS 滑动默认滚动效果
export const setBounce = (allow) => {
  qing.call('setBounce', {
    enable: allow ? 1 : 0, // 0-禁止，1-不禁止
  })
}

// 适配iPhone X底部偏移量
export const setWebBottomInset = (show) => {
  qing.call('setWebBottomInset', {
    show
  });
}

// 设置状态栏背景颜色及字色
export const setStatusBarColor = (obj) => {
  qing.call('setStatusBarColor', obj)
}

// 监听App转到前台
export const onAppear = (callback) => {
  qing.on('appear', function () {
    callback && callback()
  })
}

// 监听App转到后台
export const onDisappear = (callback) => {
  qing.on('disappear', function () {
    callback && callback()
  })
}

// 打开聊天界面
/**
 * 
 * @param {*} options openId：打开单聊 groupId：打开群聊 draft：预先打好的文字消息
 * @param {*} callback 
 */
export const chat = (options, callback) => {
  qing.call('chat', {
    ...options,
    success(res) {
      callback && callback(res)
    }
  })
}

// 打开轻应用(支持url和appid)
export const gotoLightApp = (obj) => {
  // 兼容获取回传数据
  if (obj.getCallbackData) {
    obj.callbackId = 'getCallbackData'
    obj.success = (res) => {
      if (res.success && res.data) {
        if (res.data.callBackId === 'getCallbackData') {
          obj.getCallbackData(res.data.callBackData);
        }
      }
    }
  }
  qing.call('gotoLightApp', obj)
}

// 设置回传数据
export const setCallBackData = (data, callback) => {
  if (typeof (data) === 'object') {
    data = JSON.stringify(objectData)
  }
  qing.call('setCallBackData', {
    callBackData: data,
    success: function () {
      callback && callback()
    }
  });
}

// 跳转第三方应用
export const gotoApp = ({ scheme, host, downloadUrl }, callback) => {
  // 'yunzhijia://p?url=https://itunes.apple.com/cn/app/id595672427'
  // 第三方应用跳转协议Scheme。
  // 其中url是必须的，表示应用的下载地址。
  // 如果手机未安装应用，则跳转至此地址进行安装；
  // 如果还需其他参数，则使用 & 接到后面；
  // 如果是Android，也可定义为：packageName://className?key=value&key=value;
  qing.call('gotoApp', {
    data: scheme + host + 'p?url=' + downloadUrl,
    success: function (result) {
      callback && callback("result -> " + JSON.stringify(result));
    }
  });
}

// 创建右上角图表 ???
export const addTopRightLink = (callBackId) => {
  // V10 首页导航栏定义桥（针对V10导航特殊定制不与老版本二级的导航栏混用。）
  qing.call('defHomeMainTitleBar', {
    //标题
    title: {
      text: '', // 针对立白不显示标题，填空即可,不用改
      visible: true,
    },
    // 从最右数第一个按钮(这边默认显示云之家的应用中心图标，后面可定制化立白图标，后面再改)
    firstRight: {
      callbackId: callBackId, //点击右上角图标的回调函数名称，然后可以在回调函数里写，我点击右上角图标是跳转其他页面，还是事件操作
      visible: true,
    },
  })
}

// 首页 V10 风格导航栏按钮设置
export const defHomeMainTitleBar = (options, callback) => {
  qing.call('defHomeMainTitleBar', {
    ...options,
    success(res) {
      callback && callback(res)
    },
    error(err) {
      callback && callback(err)
    },
  })
}

// 解密手机号
export const decryptphone = ({ cipherNum }, callback) => {
  qing.call('decryptPhone', {
    cipherNum: cipherNum,
    success(res) {
      callback && callback(res)
    },
    error(err) {
      callback && callback(err)
    },
  })
}

// 弹窗提示
export const toast = (message) => {
  qing.call('toast', {
    msg: message,
    type: "info"
  })
}

// 旋转屏幕 屏幕方向："landscape"表示横屏，"portrait"表示竖屏
export const rotateUI = (isHengPing) => {
  qing.call('rotateUI', {
    orientation: !!isHengPing ? 'landscape' : 'portrait'
  });
}

// 获取用户网络类型
export const getNetworkType = (callback) => {
  qing.call('getNetworkType', {
    success(res) {
      callback && callback(res)
    },
    error(err) {
      callback && callback(err)
    },
  })
}

// 监听网络状态变化
export const networkAvailable = (callback) => {
  qing.on('networkAvailable', () => {
    callback && callback()
  })
}
export const networkDisAvailable = (callback) => {
  qing.on('networkDisAvailable', () => {
    callback && callback()
  })
}

// 缓存相关
export const setStorage = (key, value, callback) => {
  // 客户端只能缓存字符串
  let _value = JSON.stringify({
    type: typeof value, // 缓存数据类型
    value,
  })
  qing.call('storage.setItem', {
    key,
    value: _value,
    success: () => {
      callback && callback()
    }
  })
}
export const getStorage = (key, callback, errorHandle) => {
  qing.call('storage.getItem', {
    key,
    success: (e) => {
      if (e.data.value) {
        let obj = JSON.parse(e.data.value)
        let result = obj.value
        callback && callback(result)
      } else {
        errorHandle && errorHandle()
      }
    },
    error: () => {
      errorHandle && errorHandle()
    }
  })
}
export const removeStorage = (key, callback) => {
  qing.call('storage.removeItem', {
    key,
    success: () => {
      callback && callback()
    }
  })
}
export const clearStorage = (callback) => {
  qing.call('storage.clear', {
    success: () => {
      callback && callback()
    }
  })
}

// 打开已安装的地图软件
export const openMapRouter = () => {
  qing.call('openMapRouter')
}

// 获取自己的信息
export const getPersonInfo = (callback) => {
  qing.call('getPersonInfo', {
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 跳转到人员详情页
export const gotoPersonInfo = (openId, callback) => {
  qing.call('personInfo', {
    openId,
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 选择文件(支持多选)
export const selectFile = (callback) => {
  qing.call('selectFile', {
    success: (result) => {
      callback && callback(result)
    }
  });
}
// 查看文件
export const showFile = (file, callback) => {
  qing.call('showFile', {
    ...file,
    success: (result) => {
      callback && callback(result)
    }
  });
}

//#region 音频相关
// 开始录音
export const startRecord = (callback, errorHandle) => {
  qing.call('startRecord', {
    success: (result) => {
      callback && callback(result)
    },
    error: () => {
      errorHandle && errorHandle()
    }
  });
}
// 停止录音
export const stopRecord = (callback) => {
  qing.call('stopRecord', {
    success: (result) => {
      callback && callback(result)
    }
  });
}
/**
 * 播放音频
 * @param {*} localId 录音文件会保存在本地，这个id用客户端返回的
 * @param {*} callback 
 */
export const playVoice = (localId, callback) => {
  qing.call('playVoice', {
    localId,
    resume: false,
    success: (result) => {
      callback && callback(result)
    }
  });
}
/**
 * 暂停播放音频
 * @param {*} localId 录音文件会保存在本地，这个id用客户端返回的
 * @param {*} callback 
 */
export const pauseVoice = (localId, callback) => {
  qing.call('pauseVoice', {
    localId,
    success: (result) => {
      callback && callback(result)
    }
  });
}
/**
 * 继续播放音频
 * @param {*} localId 录音文件会保存在本地，这个id用客户端返回的
 * @param {*} callback 
 */
export const resumeVoice = (localId, callback) => {
  qing.call('playVoice', {
    localId,
    resume: true,
    success: (result) => {
      callback && callback(result)
    }
  });
}
/**
 * 停止播放音频
 * @param {*} localId 录音文件会保存在本地，这个id用客户端返回的
 * @param {*} callback 
 */
export const stopVoice = (localId, callback) => {
  qing.call('stopVoice', {
    localId,
    success: (result) => {
      callback && callback(result)
    }
  });
}
//#endregion

/**
 * 身份验证
 * @param {*} type 验证类型
 * @param {*} appId 轻应用ID
 * @param {*} callback 
 */
export const validate = (type, appId, callback) => {
  qing.call('validate', {
    type,
    lightAppId: appId,
    prompt: '为保证数据安全',
    ignoreYzjPwd: false,
    success: (result) => {
      callback && callback(result)
    }
  })
}

/**
 * 选择图片
 * @param {*} type 类型，“camera”代表“相机”，“photo”代表“相册”，不传表示从相机、相册中选择（Qing/0.9.10及以上支持。）
 * @param {*} callback 
 */
export const selectPic = (type, callback) => {
  qing.call('selectPic', {
    type,
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 拍照或从手机相册中选图
export const chooseImage = ({ type, isMulti, maxSelectCount }, callback) => {
  qing.call('chooseImage', {
    type,
    isMulti,
    maxSelectCount,
    needCut: false,
    showOrigin: false,
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 获取本地图片接口（仅iOS）
// 备注：此接口仅在 iOS WKWebview 下提供，用于兼容 iOS WKWebview 不支持 localId 直接显示图片的问题。
export const getLocalImgDataForIos = (localId, callback) => {
  qing.call('getLocalImgData', {
    localId,
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 保存图片到相册
export const savePhoto = (url, callback) => {
  qing.call('savePic', {
    url,
    success: (result) => {
      callback && callback(result)
    }
  });
}

/** 
 * 从相册选择图片、视频或拍照、录像上传（通用版）
 * @param {*} type 	'camera'代表'相机'，'photo'代表'相册'，不传表示从相机、相册中选择 
 * showMode  展示模式 showMode 0; 只展示图片 showMode 1; 只展示视频
 * timeoutInterval 请求超时时⻓ （秒), 可以设置10、30、60三个值
 * 
*/
export const selectVideo = (type, callback) => {
  qing.call('selectPicUpload', {
    type,
    uploadUrl: "https://mtp-test.myoas.com/log-service/demo/upload",
    maxSelectCount: 3,
    isMulti: false,
    showOrigin: false,
    name: "file",
    showMode: 1,
    params: {
    },
    header: {
    },
    "timeoutInterval": 60,
    success: (result) => {
      callback && callback(result)
    },
    error(err) {
      callback && callback(err)
    }
  })
}

//#region 视频相关
export const startRecordVideo = (callback) => {
  qing.call('video.startRecord', {
    success: (result) => {
      callback && callback(result)
    }
  });
}

export const playVideo = (localId) => {
  qing.call('video.play', {
    localId,
    success: (result) => {
      console.info(result)
    },
    error: (err)=> {
      console.info(err)
    },
  });
}
//#endregion

//#region 设备相关
export const getSysInfo = (callback) => {
  callback && callback(navigator.userAgent)
}

// 获取粘贴板内容
export const getClipBoard = (callback) => {
  qing.call('clipBoard', {
    type: 'getString',
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 设置粘贴板
export const setClipBoard = (string, callback) => {
  qing.call('clipBoard', {
    type: 'setString',
    string,
    success: (result) => {
      callback && callback(result)
    }
  });
}

/**
 * 扫码
 * @param {*} type // 扫码类型（'qrCode'：二维码,'barCode':条码,''：二维码/条码）
 */
// data:{
//   "qrcode_str":"xxx"  // 扫码返回的结果，该结果在needResult为1的时候；当needResult为0时，data字段不返回。
// }
export const scanQRCode = (type, callback) => {
  qing.call("scanQRCode", {
    needResult: 1,
    type,
    success: (result) => {
      callback && callback(result)
    }
  });
}

/** 
 * 连续扫码
 * @param {*} typeSelect // 扫码类型（【0：条形码，1：二维码】，不传或传 0、1 以外的数字默认【条形码】）
 * @param {*} scanInterval // 识别间隔，默认【1.0s】
 * @param {*} needSingleReport // 是否需要单次上报（true：单次上报，需最后回调取消或完成状态给JS，false：批量上报，
 *                                只需用户点“完成”时一次性上报给js），默认不需要单次上报 
 * needSingleReport 设置为true时，需要配合scanCodeCheckResult使用，可以进行业务端码校验
*/
export const continuousScanQRCode = (typeSelect, callback) => {
  qing.call('scanCodeContinuously', {
    typeSelect,
    scanInterval: 1.0,
    success: (result) => {
      callback && callback(result)
    }
  })
}

/** 
 * 扫描代码检查结果
 * @param {*} message // 扫码数据前端校验结果信息
 * @param {*} success // 扫码数据前端校验是否成功
 * 
*/
export const scanCodeCheck = (message, success, callback) => {
  qing.call('scanCodeCheckResult', {
    message,
    success,
    success: (result) => {
      callback && callback(result)
    }
  })
}

// 打开蓝牙
export const openBluetooth = (callback) => {
  qing.call("bluetooth.openBluetoothAdapter", {
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 关闭蓝牙
export const closeBluetooth = (callback) => {
  qing.call("bluetooth.closeBluetoothAdapter", {
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 获取所有已发现的蓝牙设备
export const getBluetoothDevices = (callback) => {
  qing.call("bluetooth.getBluetoothDevices", {
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 搜索蓝牙设备
export const searchBluetoothDevices = (callback) => {
  qing.call("bluetooth.startBluetoothDevicesDiscovery", {
    success: (result) => {
      callback && callback(result)
    }
  });
}

// 停止搜索蓝牙设备
export const stopSearchBluetoothDevices = (callback) => {
  qing.call("bluetooth.stopBluetoothDevicesDiscovery", {
    success: (result) => {
      callback && callback(result)
    }
  });
}

//#endregion
